// TODO: at some point we should move these out as they have application smarts
export type StorageKey = 'userInfo' | 'emailSignedUp' | 'CREATermsAccepted' | 'uuid' | 'roomBuilderDebugUrl'

export const ORIGIN_HOST = process.env['NEXT_PUBLIC_VERCEL_URL']
  ? `https://${process.env['NEXT_PUBLIC_VERCEL_URL']}`
  : process.env['NEXT_PUBLIC_HOST']
